import { KoobInputCheckbox } from '@koob/ui';
import { useTranslation } from 'react-i18next';
import ActiveJobTooltip from '../../../../components/ActiveJobTooltip';

function RequestState({ state }) {
  const { t } = useTranslation('toConnectionRequest');

  const states = {
    confirmed: {
      text: t('bulkEdit.requestSelector.state.confirmed'),
      color: 'text-green-500',
    },
    pending: {
      text: t('bulkEdit.requestSelector.state.pending'),
      color: 'text-k-orange',
    },
    refused: {
      text: t('bulkEdit.requestSelector.state.refused'),
      color: 'text-red-500',
    },
  };

  return (
    <div className={`italic text-sm ${states[state]?.color}`}>
      {states[state]?.text}
    </div>
  );
}

function RequestTypeIcon({ type }) {
  const types = {
    hotel: 'far fa-bed',
    experience: 'far fa-layer-group',
    template: 'far fa-copy',
  };

  return <i className={`${types[type]} text-blue-500`} />;
}

export default function BulkEditRequestsSelectorCheckbox({
  request,
  selected,
  setSelected,
  updating,
}) {
  return (
    <div className={['w-full', updating ? 'opacity-60' : ''].join(' ')}>
      <KoobInputCheckbox
        key={request.id}
        checked={selected}
        onCheckedChange={setSelected}
        disabled={updating}
      >
        <div className="flex space-x-2 items-center">
          <RequestTypeIcon type={request.type} />

          <div className="leading-none text-sm text-gray-600 font-medium">
            <div>{request?.toOrganization?.name}</div>

            <div className="mt-1 flex space-x-1.5 items-center">
              <RequestState state={request.state} />

              {updating && (
                <ActiveJobTooltip position="left">
                  <i className="fas fa-circle-notch fa-spin text-gray-400" />
                </ActiveJobTooltip>
              )}

              <a
                href={`/to-connection-request/connections/${request.id}/${request.type}s`}
                className="text-xs text-gray-300 hover:text-gray-500 transition"
                target="_blank"
                rel="noreferrer"
              >
                <i className="far fa-pen" />
              </a>
            </div>
          </div>
        </div>
      </KoobInputCheckbox>
    </div>
  );
}
